import { render, staticRenderFns } from "./Observatorio.vue?vue&type=template&id=4497e7aa&"
import script from "./Observatorio.vue?vue&type=script&lang=js&"
export * from "./Observatorio.vue?vue&type=script&lang=js&"
import style0 from "./Observatorio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports